import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterContainerComponent } from '@kempower-nx-workspace/layout-templates';

@Component({
    selector: 'ctep-core-footer',
    imports: [CommonModule, FooterContainerComponent],
    templateUrl: './ctep-footer.component.html',
    styleUrl: './ctep-footer.component.scss'
})
export class CtepFooterComponent {}
